/*运行在浏览器 / 客户端环境（或 Node.js 服务端运行时）
可依赖浏览器 API、项目内工具函数、路径别名
会被打包到最终产物中，可动态获取运行时信息（如设备类型、URL 参数）*/
import {
  unitPrecision,
  designRatio,
  divisor,
  maxDisplayWidth,
  designWidth,
  dkPadDesignWidth,
  dkPadDesignRatio,
} from "@/constants/common.config";
import { _css } from "@/utils/dom";

const calcByUiRatio = () => {
  return Math.min(maxDisplayWidth, window.innerWidth) / designWidth;
};
// 定义空气质量指数最大值常量
const MAX_AQI_VALUE = 500;
export {
  unitPrecision,
  designRatio,
  divisor,
  maxDisplayWidth,
  designWidth,
  dkPadDesignWidth,
  dkPadDesignRatio,
  calcByUiRatio,
  MAX_AQI_VALUE,
};

// 定义需要匹配的svg名称数组（带dk_前缀）
const targetSvgNames = [
  "dk_sunset_v2",
  "dk_sunrise_v2",
  "dk_2",
  "dk_3",
  "dk_4",
  "dk_5",
  "dk_6",
  "dk_7",
  "dk_12",
  "dk_18",
  "dk_34",
  "dk_35",
  "dk_36",
  "dk_38",
];

// 核心：解析WeatherIconImg，生成匹配用的svg名称并判断是否命中
export const parseSvgInfo = (item: any) => {
  // 兜底：无WeatherIconImg时直接返回不匹配
  if (!item?.WeatherIconImg) return { isMatch: false, svgName: "" };

  // 步骤1：从路径中提取纯文件名（如 "/weather/images/sunset_v2.svg" → "sunset_v2"）
  const pureFileName = item.WeatherIconImg.split("/") // 分割路径成数组
    .pop() // 取最后一段（sunset_v2.svg）
    ?.replace(/\.svg$/, ""); // 精准移除.svg后缀（避免匹配到其他字符）

  // 步骤2：拼接dk_前缀，判断是否在目标数组中
  if (!pureFileName) return { isMatch: false, svgName: "" };
  const fullSvgName = `dk_${pureFileName}`;
  const isMatch = targetSvgNames.includes(fullSvgName);

  return { isMatch, svgName: fullSvgName };
};
